<template>
  <GwMenu
    placement="bottom-start"
    :flOptions="{ offset: 0, padding: 0 }"
    :ignoreDataGwmenu="true"
    :zIndexContent="99"
  >
    <template #opener>
      <div
        class="gw_btn-v1 text-medium px-2"
        style="--height: var(--height-td)"
        data-tst="btn_overwrite_item"
      >
        <div class="mdi mdi-content-save-move mr-2"></div>
        {{ $t('btn.overwrite') }}
      </div>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu f-column"
        style="padding: 0.5rem 0.25rem; gap: 0.25rem"
        data-gwmenu="noclose"
      >
        <div
          class="gw_btn text-small anim-fade-in w-100"
          style="--clr-back: var(--clr-primary); --height: 1.75rem"
          data-tst="btn_confirm_overwrite"
          @click.stop="$emit('overwrite:item', item)"
        >
          {{ $t('btn.confirm_overwrite') }}
        </div>
        <div
          class="gw_btn text-small anim-fade-in w-100"
          style="--height: 1.75rem"
          @click.stop="methods.toggleOpen(false)"
        >
          {{ $t('btn.cancel_overwrite') }}
        </div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'

export default {
  name: 'OverwriteTreeSettingsMenu',
  components: {
    GwMenu,
  },
  props: {
    item: Object,
  },
  emits: ['overwrite:item'],
}
</script>
